// app/Scripts/Components/fields.js
(function() {
	'use strict'
	
	// queryAll lokal definieren
	function queryAll(sel, ctx) {
		ctx = ctx || document
		return Array.prototype.slice.call(ctx.querySelectorAll(sel))
	}
	
	// Einfache Autosize-Funktion
	function autosize(textareas) {
		textareas.forEach(function(textarea) {
			if (!textarea) return
			
			function resize() {
				textarea.style.height = 'auto'
				textarea.style.height = textarea.scrollHeight + 'px'
			}
			
			textarea.addEventListener('input', resize)
			resize()
		})
	}
	
	// Initialisierung
	function initFields() {
		autosize(queryAll('textarea'))
		console.log('Fields: Autosize initialisiert')
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFields)
	} else {
		initFields()
	}
	
})()